import { useState, useEffect } from 'react';
import { Container, Table, Badge, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getPlansWithStatus } from '../../api/planApi';

const cyan = '#00e5ff';
const th = { color: cyan, fontWeight: 600, fontSize: 13, padding: '14px 20px', border: 'none' };

const Slots = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    getPlansWithStatus()
      .then((res) => setPlans(res.data.plans))
      .catch((err) => setError(err.response?.data?.message || 'Failed to load slots. Please try again.'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <Container className="mt-5 text-center">
      <Spinner animation="border" style={{ color: cyan }} />
    </Container>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#0a0a0a', paddingBottom: 40 }}>
      <Container className="pt-4">
        <h5 style={{ color: '#fff', fontWeight: 700, marginBottom: 4 }}>Buy Slots</h5>
        <div style={{ color: '#888', fontSize: 13, marginBottom: 24 }}>
          Each slot can be purchased once. Purchasing enters you into that slot's cycle tree.
        </div>

        {error && (
          <div style={{ color: '#ff6666', background: 'rgba(200,50,50,0.12)', border: '1px solid rgba(200,50,50,0.3)', borderRadius: 8, padding: '12px 16px', marginBottom: 16, fontSize: 13 }}>
            {error}
          </div>
        )}

        <div style={{ borderRadius: 12, overflow: 'hidden', border: '1px solid rgba(0,229,255,0.12)' }}>
          <Table responsive className="mb-0" style={{ background: 'transparent' }}>
            <thead>
              <tr style={{ background: 'rgba(0,229,255,0.07)', borderBottom: '1px solid rgba(0,229,255,0.15)' }}>
                <th style={th}>#</th>
                <th style={th}>Slot</th>
                <th style={th}>Status</th>
              </tr>
            </thead>
            <tbody>
              {plans.map((plan, idx) => (
                <tr
                  key={plan._id}
                  style={{
                    borderBottom: '1px solid rgba(255,255,255,0.05)',
                    background: idx % 2 === 0 ? 'rgba(255,255,255,0.02)' : 'transparent',
                  }}
                >
                  <td style={{ color: '#666', fontSize: 13, padding: '14px 20px', border: 'none' }}>{idx + 1}</td>
                  <td style={{ padding: '14px 20px', border: 'none' }}>
                    <div style={{ color: '#fff', fontWeight: 600, fontSize: 14 }}>{plan.planName}</div>
                    <div style={{ color: '#66ff99', fontWeight: 700, fontSize: 13, marginTop: 2 }}>{plan.amount} USDT</div>
                  </td>
                  <td style={{ padding: '14px 20px', border: 'none' }}>
                    {plan.purchased ? (
                      <div>
                        <Badge style={{ background: 'rgba(102,255,153,0.15)', color: '#66ff99', border: '1px solid #66ff9955', fontWeight: 500, fontSize: 12, padding: '5px 12px' }}>
                          Purchased
                        </Badge>
                        {plan.purchasedAt && (
                          <div style={{ color: '#555', fontSize: 11, marginTop: 4 }}>
                            {new Date(plan.purchasedAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
                          </div>
                        )}
                      </div>
                    ) : (
                      <button
                        onClick={() => navigate(`/slots/buy/${plan._id}`)}
                        style={{
                          background: 'transparent',
                          border: `1px solid ${cyan}`,
                          color: cyan,
                          borderRadius: 6,
                          padding: '4px 16px',
                          fontSize: 13,
                          fontWeight: 600,
                          cursor: 'pointer',
                        }}
                      >
                        Buy Now
                      </button>
                    )}
                  </td>
                </tr>
              ))}
              {plans.length === 0 && (
                <tr>
                  <td colSpan={3} style={{ color: '#555', textAlign: 'center', padding: '32px', border: 'none' }}>
                    No slots available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Container>
    </div>
  );
};

export default Slots;
